import React, { useEffect, useRef } from "react";
import { Img } from "../../constants/common/StyledGlobalConstants";
import * as StyledGlobalCSS from "../../constants/common/StyledGlobalConstants";
import EmptylistIcon from "../../assets/images/Empty-list.png";
import GenericErrorImg from "../../assets/images/Generic-error.png";
import PropTypes from "prop-types";

const EmptylistNotification = ({ children, title, genericError = false, isJobFailed = false }) => {
  const titleRef = useRef(null);

  useEffect(() => {
    if (isJobFailed && titleRef.current) {
      titleRef.current.focus();
    }
  }, [isJobFailed]);
  return (
    <StyledGlobalCSS.Wrapper marginTop="5rem" textAlign="center" role="alert">
      <Img
        src={genericError ? GenericErrorImg : EmptylistIcon}
        width="100px"
        height="100px"
        alt={genericError ? "Generic error" : "Empty list"}
      />
      <StyledGlobalCSS.TextWrapper
        fontFamily="Neue Haas Grotesk Text Std"
        fontSize="14px"
        fontWeight="700"
        lineHeight="20px"
        margin="1.8rem 0 0 0"
        ref={titleRef}
        tabIndex="-1"
      >
        {title}
      </StyledGlobalCSS.TextWrapper>
      <StyledGlobalCSS.Wrapper
        display="flex"
        justifyContent="center"
        fontFamily="Neue Haas Grotesk Text Std"
        fontSize="14px"
        lineHeight="20px"
        margin="8px 0 0 0"
        gap="2px"
      >
        {children}
      </StyledGlobalCSS.Wrapper>
    </StyledGlobalCSS.Wrapper>
  );
};


EmptylistNotification.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  genericError: PropTypes.bool,
  isJobFailed: PropTypes.bool,
};

export default EmptylistNotification;
